// extracted by mini-css-extract-plugin
module.exports =  {"tc-list-list":"ListGrid-module__tc-list-list___An9oO"};